import {useContext} from 'react'
import {StateContext} from "./GlobalState.jsx";


export function GetText() {

    let {lang} = useContext(StateContext)

    let text = "";

    if(lang === "ua"){
       text = {
           Header:{
               name: "Авторозборка Zapauto",
               desc: "Авторозборка, вживані запчастини",
               menu1: "Головна",
               menu2: "Каталог товарів",
               menu3: "Авто в розборі",
               menu4: "Контакти",
           },
           Search:{
               searchPlaceholder: "Пошук",
               searchButton: "Знайти"
           },
           Home:{
               description1: "Ласкаво просимо на наш сайт!",
               description2: "Тут ви знайдете широкий вибір вживаних запчастин за доступними цінами.",
               description3: "Наш каталог товарів постійно оновлюється. Якщо ви не знайшли потрібну запчастину, зв'яжіться з нами телефоном або електронною поштою!",
               description4: "Сайт",
               description5: "є інтернет-каталогом та вітриною якісних вживаних запчастин."
           },
           Cars:{
               title: "Нові надходження авто в розбір"
           },
           Contacts:{
               title: "Контакти",
               tel: "Телефони",
               email: "Email",
               schedule: "Графік роботи",
               scheduleDay: "Пн-Сб",
               scheduleDay2: "Нд",
               address: "Адреса складу",
               addressInfo: "Київська обл., Вишгородський р-н, с. Нові Петровці, вул. Соборна 75 (склад працює за дзвінком, перед приїздом прохання зателефонувати).",
               delivery: "Гарантія та повернення",
               deliveryInfo: "- за умови, якщо деталь не робоча, проводиться заміна на іншу (доставка деталі здійснюється за наш рахунок у дві сторони), або якщо деталь відсутня в наявності, здійснюється повернення коштів у повному обсязі;",
               deliveryInfo2: "- за умови повернення робочої деталі, стягується 10% від її вартості, за користування нею;",
               deliveryInfo3: "- доставка по всій Україні або самовивіз;",
               deliveryInfo4: "- гарантійний термін на деталі - 14 днів.",
               nedila: "вихідний",
               avtoPro: "Ми є партнером avto.pro"
           },
           Catalog:{
               title: "Каталог товарів"
           },
           ProductItem:{
               cartButton: "В кошик",
               detailButton: "Детальніше",
               Category: "Категорія: ",
               selCategory: "Виберіть категорію:"
           },
           ProductDetail:{
               searchPart: "Знайдено деталей по коду",
               count: "шт.",
               cartButton: "В кошик",
               close: "Закрити",
               stock: "В наявності",
               conditionOld: "Стан: вживаний, оригінал.",
               conditionNew: "Стан: новий.",
               dostavka: "Варіанти доставки:",
               oplata: "Оплата товару:",
               protovar: "Про товар:",
               desc1: "- Самовивіз с. Нові Петрівці, вул. Соборна 75 (безкоштовно)",
               desc2: "- Доставка по Україні 1-3 дні службою доставки (за тарифами перевізника)",
               desc3: "- Готівкою (оплата після отримання товару зі складу)",
               desc4: "- За реквізитами ФОП (оплата безготівково без ПДВ)",
               desc5: "- Післяплата / наложений платіж (після передоплати за доставку)",
               desc6: "- Усі запчастини привезені з Європи, без пробігу по Україні",
               desc7: "- Гарантія на установку та перевірку 14 днів"


           },
           FavoriteItem:{
               detailButton: "Детальніше",
               removeButton: "Видалити"
           },
           Cart:{
               namePlaceholder: "Ваше ім'я",
               telPlaceholder: "Телефон",
               noItem: "Товар в кошику відсутній",
               totalItems: "Товарів",
               total: "Загальна сума",
               checkout: "Купити",
               reset: "Очистити"
           },
           CartItem:{
               quantity: "Кількість"
           },
           Footer:{
               title: "Авторозборка Zapauto"
           }
        }
    }

    if(lang === "ru"){
        text = {
            Header:{
                name: "Авторазборка Zapauto",
                desc: "Авторазборка, запчасти б/у",
                menu1: "Главная",
                menu2: "Каталог товаров",
                menu3: "Авто в разборе",
                menu4: "Контакты",
            },
            Search:{
                searchPlaceholder: "Поиск",
                searchButton: "Искать"
            },
            Home:{
                description1: "Добро пожаловать на наш сайт!",
                description2: "У нас Вы можете найти большое количество б/у запчастей за небольшие деньги.",
                description3: "Каталог товаров регулярно пополняется, если вы не нашли подходящую запчасть — свяжитесь с нами по телефону или по почте!",
                description4: "Сайт",
                description5: "представляет из себя интернет-каталог, витрину б/у запчастей."
            },
            Cars:{
                title: "Свежие поступления авто в разбор"
            },
            Contacts:{
                title: "Контакты",
                tel: "Телефоны",
                email: "Email",
                schedule: "График работи",
                scheduleDay: "Пн-Сб",
                scheduleDay2: "Вс",
                address: "Адрес склада",
                addressInfo: "Киевская обл., Вышгородский р-н, с. Новые Петровцы, ул. Соборная 75 (склад работает по звонку, перед приездом просьба позвонить).",
                delivery: "Гарантия и возврат",
                deliveryInfo: "- при условии, если деталь не рабочая, производится замена на другую (доставка детали осуществляется за наш счет в две стороны), или если деталь отсутствует в наличии, производится возврат средств в полном объеме;",
                deliveryInfo2: "- при возврате рабочей детали, взимается 10% от ее стоимости, за пользование ею;",
                deliveryInfo3: "- доставка по всей Украине или самовывоз;",
                deliveryInfo4: "- гарантийный срок на детали – 14 дней.",
                nedila: "выходной",
                avtoPro: "Мы партнеры avto.pro"
            },
            Catalog:{
                title: "Каталог товаров"
            },
            ProductItem:{
                cartButton: "В корзину",
                detailButton: "Подробнее",
                Category: "Категория: ",
                selCategory: "Выберите категорию:"
            },
            ProductDetail:{
                searchPart: "Найдено деталей по коду",
                count: "шт.",
                cartButton: "В корзину",
                close: "Закрыть",
                stock: "В наличии",
                conditionOld: "Состояние: Б/у, оригинал.",
                conditionNew: "Состояние: новый.",
                dostavka: "Варианты доставки:",
                oplata: "Оплата товара:",
                protovar: "О товаре:",
                desc1: "- Самовывоз с. Новые Петровцы, ул. Соборная 75 (бесплатно)",
                desc2: "- Доставка по Украине 1-3 дня службой доставки (по тарифам перевозчика)",
                desc3: "- Наличными (оплата по факту получения товара из нашего склада)",
                desc4: "- По реквизитам ФЛП (оплата по безналичному расчету без НДС)",
                desc5: "- Наложенный платеж / наложенный платеж (после предоплаты за доставку)",
                desc6: "- Все запчасти привезены с Европы, без пробега по Украине",
                desc7: "- На установку и проверку гарантия 14 дней"
            },
            FavoriteItem:{
                detailButton: "Подробнее",
                removeButton: "Удалить"
            },
            Cart:{
                namePlaceholder: "Ваше имя",
                telPlaceholder: "Телефон",
                noItem: "Товар в корзине отсутствует",
                totalItems: "Товаров",
                total: "Общая сумма",
                checkout: "Купить",
                reset: "Очистить"
            },
            CartItem:{
                quantity: "Количество"
            },
            Footer:{
                title: "Авторазборка Zapauto"
            }
        }
    }


    if(lang === "en"){
        text = {
            Header:{
                name: "Junkyard  Zapauto",
                desc: "Junkyard, used parts",
                menu1: "Home",
                menu2: "Catalog",
                menu3: "Latest cars",
                menu4: "Contacts",
            },
            Search:{
                searchPlaceholder: "Search",
                searchButton: "Find"
            },
            Home:{
                description1: "Welcome to our website!",
                description2: "Here you can find a large number of used parts for cheap.",
                description3: "The catalog of goods is updated regularly, if you did not find a suitable spare part - сontact us via phone or email!",
                description4: "Website",
                description5: "is an online catalog, a showcase of used spare parts."
            },
            Cars:{
                title: "New arrivals of cars"
            },
            Contacts:{
                title: "Contacts",
                tel: "Tel",
                email: "Email",
                schedule: "Work time",
                scheduleDay: "Mon-Sat",
                scheduleDay2: "Sun",
                address: "Warehouse address",
                addressInfo: "Kyiv region, Vyshgorodsky district, v. Novi Petrivtsi, st. Soborna 75 (if you plan to visit us, please call early).",
                delivery: "Warranty and returns",
                deliveryInfo: "- on the condition that the part is not working, it is replaced with another one (delivery of the part is carried out at our expense in two directions), or if the part is not available, a full refund is made;",
                deliveryInfo2: "- when returning a working part, 10% of its value will be charged for the use of it;",
                deliveryInfo3: "- delivery throughout Ukraine or self pickup;",
                deliveryInfo4: "- warranty period for parts - 14 days.",
                nedila: "day off",
                avtoPro: "We are partners with avto.pro"
            },
            Catalog:{
                title: "Catalog"
            },
            ProductItem:{
                cartButton: "To cart",
                detailButton: "More details",
                Category: "Category: ",
                selCategory: "Select a category:"
            },
            ProductDetail:{
                searchPart: "Found details by code",
                count: "pcs.",
                cartButton: "To cart",
                close: "Close",
                stock: "In stock",
                conditionOld: "Condition: used, original.",
                conditionNew: "Condition: new.",
                dostavka: "Delivery options:",
                oplata: "Payment for goods:",
                protovar: "About the product:",
                desc1: "- Pickup from Novi Petrivtsi, Soborna Street 75 (free)",
                desc2: "- Delivery across Ukraine in 1-3 days by delivery service (according to carrier rates)",
                desc3: "- Cash (payment upon receipt of goods from our warehouse)",
                desc4: "- By requisites of FOP (non-cash payment without VAT)",
                desc5: "- Cash on delivery / COD (after prepayment for delivery)",
                desc6: "- All parts are brought from Europe, with no mileage in Ukraine",
                desc7: "- 14-day warranty for installation and inspection"

            },
            FavoriteItem:{
                detailButton: "More details",
                removeButton: "Remove from Favorite"
            },
            Cart:{
                namePlaceholder: "Name",
                telPlaceholder: "Telephone",
                noItem: "No Item in Cart!",
                totalItems: "Items",
                total: "Total amount",
                checkout: "Buy",
                reset: "reset"
            },
            CartItem:{
                quantity: "Quantity"
            },
            Footer:{
                title: "Junkyard  Zapauto"
            }
        }
    }


    return text

}




